











































































import { IContract, IContractProduct } from "@/models/contracts";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      getBillingCycleName: "constants/getBillingCycleName"
    })
  }
})
export default class ChangeProductSwitcher extends Vue {
  @Prop({ required: true })
  public oldContract!: IContract;

  @Prop({ required: true })
  public oldProduct!: IContractProduct;

  @Prop({ required: true })
  public newProduct!: any;

  @Prop({ default: false })
  public isProcessing!: boolean;
}
